<template>
  <div>
    <div class="img-wrap">
      <img src="../../assets/image/logo.png" alt="" />
    </div>
    <h5>{{ head_line_title }}</h5>
  </div>
</template>

<script>
export default {
  props: {
    head_line_title: {
      type: String,
      default: () => {
        return '弘策科技欢迎您';
      },
    },
  },
};
</script>

<style lang="less" scoped>
.img-wrap {
  margin: 120px 0 40px 0;
  text-align: center;
  img {
    width: 158px;
    height: 64px;
  }
}
h5 {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #1b1b1b;
  line-height: 28px;
  text-align: center;
}
</style>
